import type { AxiosError } from 'axios'
import { useQuery } from '@tanstack/react-query'

import type { GetAuthSessionInfoResponse } from '~/generated/client'
import { getAuthSessionInfo } from '~/generated/client'
import { NON_SIDEBAR_PATHS } from './app'

const QUERY_KEY = {
  USER_METADATA: 'userMetadata',
  USER: 'user',
}

export const useUser = ({
  onError,
}: {
  onError?: (data: GetAuthSessionInfoResponse, status: number) => void
} = {}) => {
  const isNonSidebarPage = NON_SIDEBAR_PATHS.includes(window.location.pathname)
  const { data, isLoading, isError, isSuccess, refetch } = useQuery({
    queryKey: [QUERY_KEY.USER],
    queryFn: getAuthSessionInfo,
    enabled: !isNonSidebarPage,
    onError: (error: AxiosError) => {
      if (error?.status === 401) {
        onError?.(
          error.response?.data as GetAuthSessionInfoResponse,
          error?.status,
        )
      }
    },
    retry: 1,
    staleTime: 60000,
  })
  if (window.opener && data) {
    window.opener.postMessage(data, '*')
  }

  return {
    user: data,
    userEmail: data?.org_member?.email,
    isLoading,
    isError,
    isSuccess,
    refetch,
  }
}

export const useApiKey = () => {
  const { user } = useUser()

  return user?.apiKey?.key ?? undefined
}
